import script from "./QuizSearchPage.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizSearchPage.vue?vue&type=script&setup=true&lang=js"

import "./QuizSearchPage.vue?vue&type=style&index=0&id=6feb09e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6feb09e8"]])

export default __exports__